module.exports = __webpack_public_path__ + "static/media/myCockpitPage.2e72527b.jpg";